import GitLab from './GitLab'

export default GitLab
